import { createFileRoute } from '@tanstack/react-router';
import { ReportsPage } from '@web/modules/reports/page/reports-page';
import { parseReportsSearch } from '@web/modules/reports/page/reports-search';

export const Route = createFileRoute('/_app/reports')({
  validateSearch: (search: Record<string, unknown>) => parseReportsSearch(search),
  component: ReportsRoute,
});

function ReportsRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ReportsPage
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace })}
    />
  );
}
